/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, title: NonNullable<unknown> }} Tags_Meta_DescriptionInputs */

const id_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.count} penawaran tersedia untuk ${i?.title} di egdata.app.`)
};

const ms_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.count} tawaran tersedia untuk ${i?.title} di egdata.app.`)
};

const da_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.count} tilgængelige tilbud for ${i?.title} på egdata.app.`)
};

const de_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entdecken Sie ${i?.count} verfügbare Angebote für ${i?.title} auf egdata.app.`)
};

const en_us2_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checkout ${i?.count} available offers for ${i?.title} on egdata.app.`)
};

const es_es2_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echa un vistazo a ${i?.count} juegos disponibles para ${i?.title} en egdata.app.`)
};

const es_mx2_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echa un vistazo a ${i?.count} ofertas disponibles para ${i?.title} en egdata.app.`)
};

const fil_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingnan mo ang ${i?.count} available na offer para sa ${i?.title} sa egdata.app.`)
};

const fr_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Découvrez ${i?.count} offres disponibles pour ${i?.title} sur egdata.app.`)
};

const it_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scopri ${i?.count} offerte disponibili per ${i?.title} su egdata.app.`)
};

const hu_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nézd meg a ${i?.count} elérhető ajánlatot a ${i?.title} számára az egdata.app-on.`)
};

const nl_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekijk ${i?.count} beschikbare aanbiedingen voor ${i?.title} op egdata.app.`)
};

const no_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sjekk ut ${i?.count} tilgjengelige tilbud for ${i?.title} på egdata.app.`)
};

const pl_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprawdź ${i?.count} dostępnych ofert dla ${i?.title} na egdata.app.`)
};

const pt_br2_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confira ${i?.count} jogos disponíveis para ${i?.title} no egdata.app.`)
};

const pt_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulte ${i?.count} ofertas disponíveis para ${i?.title} no egdata.app.`)
};

const ro_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vezi ${i?.count} oferte disponibile pentru ${i?.title} pe egdata.app.`)
};

const fi_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutustu ${i?.count} saatavilla olevaan tarjoukseen kohteelle ${i?.title} egdata.appissa.`)
};

const sv_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kolla in ${i?.count} tillgängliga erbjudanden för ${i?.title} på egdata.app.`)
};

const vi_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem ${i?.count} ưu đãi có sẵn cho ${i?.title} trên egdata.app.`)
};

const tr_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app'te ${i?.title} için ${i?.count} teklifi inceleyin.`)
};

const cs_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podívejte se na ${i?.count} nabídek dostupných pro ${i?.title} na egdata.app.`)
};

const bg_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Разгледайте ${i?.count} налични оферти за ${i?.title} на egdata.app.`)
};

const ru_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посмотрите ${i?.count} доступных предложений для ${i?.title} на egdata.app.`)
};

const uk_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перегляньте ${i?.count} доступних пропозицій для ${i?.title} на egdata.app.`)
};

const ar_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصفح ${i?.count} عرض متاح لـ ${i?.title} على egdata.app.`)
};

const hi_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app पर ${i?.title} के लिए ${i?.count} उपलब्ध ऑफ़र देखें।`)
};

const th_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดู ${i?.count} ข้อเสนอที่พร้อมใช้งานสำหรับ ${i?.title} บน egdata.app`)
};

const ja_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app で ${i?.title} の利用可能な ${i?.count} 件のオファーをチェック。`)
};

const zh_cn2_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.title} 下的 ${i?.count} 个可用目录项，尽在 egdata.app。`)
};

const zh_hant1_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`檢視 ${i?.title} 下的 ${i?.count} 個可用目錄項目，盡在 egdata.app。`)
};

const ko_tags_meta_description = /** @type {(inputs: Tags_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app에서 ${i?.title}에 대한 ${i?.count}개의 이용 가능한 오퍼를 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Checkout {count} available offers for {title} on egdata.app." |
*
* @param {Tags_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_meta_description = /** @type {((inputs: Tags_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_meta_description(inputs)
	if (locale === "ms") return ms_tags_meta_description(inputs)
	if (locale === "da") return da_tags_meta_description(inputs)
	if (locale === "de") return de_tags_meta_description(inputs)
	if (locale === "en-US") return en_us2_tags_meta_description(inputs)
	if (locale === "es-ES") return es_es2_tags_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_tags_meta_description(inputs)
	if (locale === "fil") return fil_tags_meta_description(inputs)
	if (locale === "fr") return fr_tags_meta_description(inputs)
	if (locale === "it") return it_tags_meta_description(inputs)
	if (locale === "hu") return hu_tags_meta_description(inputs)
	if (locale === "nl") return nl_tags_meta_description(inputs)
	if (locale === "no") return no_tags_meta_description(inputs)
	if (locale === "pl") return pl_tags_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_tags_meta_description(inputs)
	if (locale === "pt") return pt_tags_meta_description(inputs)
	if (locale === "ro") return ro_tags_meta_description(inputs)
	if (locale === "fi") return fi_tags_meta_description(inputs)
	if (locale === "sv") return sv_tags_meta_description(inputs)
	if (locale === "vi") return vi_tags_meta_description(inputs)
	if (locale === "tr") return tr_tags_meta_description(inputs)
	if (locale === "cs") return cs_tags_meta_description(inputs)
	if (locale === "bg") return bg_tags_meta_description(inputs)
	if (locale === "ru") return ru_tags_meta_description(inputs)
	if (locale === "uk") return uk_tags_meta_description(inputs)
	if (locale === "ar") return ar_tags_meta_description(inputs)
	if (locale === "hi") return hi_tags_meta_description(inputs)
	if (locale === "th") return th_tags_meta_description(inputs)
	if (locale === "ja") return ja_tags_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_meta_description(inputs)
	return ko_tags_meta_description(inputs)
});
export { tags_meta_description as "tags.meta.description" }